<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">

    <ng-template #creditPolicySummary>
      <div class="total-card">
        <p class="label">Límite: <strong>{{ summary.totalLimit | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Dispuesto: <strong>{{ summary.totalUsed | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Disponible: <strong>{{ summary.totalAvailable | number:'1.2-2' }} €</strong></p>
      </div>
    </ng-template>

    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-search-filter [value]="quickSearch" (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>

    <ng-template #expandDetail let-row>
      <app-credit-policy-detail [row]="row" (changed)="reload()"></app-credit-policy-detail>
    </ng-template>
  </div>
</div>
